export const SHOW_STATE = 'SHOW_STATE';
export const TOGGLE_ON  = 'TOGGLE_ON';

export const showModal = () => ({
      type: SHOW_STATE,
      payload:{
            show:true
      }    
})

export const toggleIAgree = () => ({
    type: TOGGLE_ON,
    payload:{
          toggleOn:false,
          show:true
      }    
})


